function initChoiceComponent() {
    const initChoiceLogic = {
        isMultipleChoiceState: false,
        choicesState: [] as Array<string>,
        handleChoiceFct(key: string, isMultiple: boolean) {
            this.isMultipleChoiceState = isMultiple;
            // Push in array if it is empty
            if (this.choicesState.length == 0) {
                this.choicesState.push(key);
            } else {
                // In case of multiple choice is allowed
                if (this.isMultipleChoiceState) {
                    // If array is not empty but dont contain choice key, push key in array
                    if ((!this.choicesState.includes(key))) {
                        this.choicesState.push(key);
                    } else {
                        // If array contains key and choice is clicked, remove key from array
                        this.choicesState.splice(this.choicesState.indexOf(key), 1);
                    }
                } else {
                    // In case of single choice
                    this.choicesState.pop();
                    this.choicesState.push(key);
                }
            }
        }
    };

    return initChoiceLogic;
}

export default initChoiceComponent();